import { useGetTracesWithErrorsQuery } from './Jaeger.generated';

interface JaegerMenuProps {
    timeframe?: number;
    service: string;
}

export function useJaeger({ timeframe, service }: JaegerMenuProps) {
    const { data, loading, error } = useGetTracesWithErrorsQuery({
        variables: {
            timeframe: timeframe || 120,
            service,
        },
    });

    if (loading || error) {
        return [];
    }

    return data?.dev?.tracesWithErrors || [];
}
